import { styled } from '@mui/material/styles';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { IconButton } from '@mui/material';
import { MOBILE_BREAKPOINT } from '@src/constants';

const StyledProjectList = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const StyledProjectListHeader = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  .title {
    font-weight: 700;
    font-size: 20px;
    color: ${COLOR.indigo.default};
  }

  .filter-title {
    min-width: 240px;
  }

  .filter-item {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }

  .text-field-project {
    background-color: ${COLOR.white};
    width: 320px;

    .MuiOutlinedInput-root {
      width: 320px;
      height: 40px;
      padding: 8px 12px 8px 12px;
      gap: 8px;
      border-radius: 8px;
    }

    .MuiInputLabel-root {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    .text-field-project {
      width: 240px;

      .MuiOutlinedInput-root {
        width: 240px;
      }
    }
  }
`;

const StyledProjectListBody = styled('div')`
  height: calc(100vh - 475px);
  overflow: auto;
`;

const StyledProjectListItem = styled('div')`
  .item-content-wrapper {
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .item-title-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .item-title-icon {
    background-color: ${COLOR.gray};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 8px;
    color: ${COLOR.darkBlue};
  }

  .item-title {
    font-size: 14px;
    font-weight: 510;
    color: ${COLOR.indigo.darkGray};
    max-width: 400px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .item-created-at {
    font-size: 12px;
    font-weight: 400;
    color: ${COLOR.indigo[32]};
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}px) {
    .item-title {
      max-width: 150px;
    }
  }
`;

const StyledIconButton = styled(IconButton)`
  width: ${({ width }) => width || 'auto'};
  padding: ${({ padding }) => padding || '0px'};
  height: ${({ height }) => height || '10px'};
  border-radius: ${({ borderRadius }) => borderRadius || '100%'};
  /* border: 1px solid ${COLOR.light}; */
  padding: 18px;
  background: ${({ focus }) => focus && TRANSPARENT_COLOR.dark};

  color: ${({ color, disabled }) =>
    disabled ? COLOR.secondary[32] : color || COLOR.darkBlue};

  .icon-disabled {
    color: ${COLOR.iconDisabledColor};
  }

  .text-action {
    font-size: 14px;
    color: ${COLOR.darkBlue};
    &:hover {
      color: ${COLOR.black};
    }
  }
  .icon-morevert {
    opacity: 0.64;
    &:hover {
      opacity: 1;
    }
  }
  &:hover {
    background-color: ${(props) => props.isDisableHover && 'transparent'};
  }
`;

export {
  StyledProjectList,
  StyledProjectListHeader,
  StyledProjectListBody,
  StyledProjectListItem,
  StyledIconButton,
};
